(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lp2-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cta = document.querySelector('.lp2-final-cta');
    if (!cta) return;
    const offer = document.querySelector('#lp2-offer');
    const update = () => {
      const scrollable = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1);
      cta.classList.toggle('is-visible', window.scrollY / scrollable >= 0.25);
    };
    if (offer && (document.body.classList.contains('template-page--gotu-kola-lp2-1') || document.body.classList.contains('template-page--gotu-kola-lp2-2') || document.body.classList.contains('template-page--nad-lp1') || document.body.classList.contains('template-page--glut-strips'))) {
      new IntersectionObserver(([entry]) => {
        cta.classList.toggle('is-obscured', entry.isIntersecting);
      }, { threshold: 0.1 }).observe(offer);
    }
    update();
    window.addEventListener('scroll', update, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp2-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-lp2-gallery]').forEach((gallery) => {
    const track = gallery.querySelector('[data-lp2-slider-track]');
    const slides = [...track.children];
    const thumbs = [...gallery.querySelectorAll('[data-lp2-gallery-thumb]')];
    const previous = gallery.querySelector('[data-lp2-gallery-prev]');
    const next = gallery.querySelector('[data-lp2-gallery-next]');
    const activate = (index) => thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === index));
    const currentIndex = () => slides.reduce((best, slide, i) => Math.abs(slide.offsetLeft - track.scrollLeft) < Math.abs(slides[best].offsetLeft - track.scrollLeft) ? i : best, 0);
    const goTo = (index) => {
      const boundedIndex = Math.max(0, Math.min(slides.length - 1, index));
      track.scrollTo({ left: slides[boundedIndex].offsetLeft, behavior: 'smooth' });
      thumbs[boundedIndex]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      activate(boundedIndex);
    };
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => {
      goTo(index);
    }));
    previous?.addEventListener('click', () => goTo(currentIndex() - 1));
    next?.addEventListener('click', () => goTo(currentIndex() + 1));
    track.addEventListener('scroll', () => {
      activate(currentIndex());
    }, { passive: true });
  });

  } catch(e) { console.error(e); }
})();
})();
